import React from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { History } from 'history';
import CustomRouter from './components/CustomRouter';
import Routes from './routes';
import Theme from './chunks/theme';
import { ApplicationState } from './store';

interface MainProps {
  store: Store<ApplicationState>;
  history: History;
}

const Main: React.FC<MainProps> = (props: MainProps) => {
  const { store, history } = props;

  return (
    <Provider store={store}>
      <CustomRouter history={history}>
        <Theme>
          <Routes />
        </Theme>
      </CustomRouter>
    </Provider>
  );
};

export default Main;
